import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class NotFoundPage extends Component {
  render() {
    const { mainSection, message } = this.props;

    return (
      <div className={mainSection ? 'main-section' : ''}>
        <h4>{message}</h4>
      </div>
    );
  }
}

NotFoundPage.defaultProps = {
  message: 'Page Is Not Found',
  mainSection: true
};

NotFoundPage.propTypes = {
  message: PropTypes.string,
  mainSection: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/containers/not-found-page.js